import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
import './cmslogin.css';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { setPartner } from "../../redux/misc-data/misc-data.action";
// import { setLoginResponse, setToken } from "../../redux/login/login.action";
import { resetMiscData, setBankLogoList, setDeviceInfo, setLoginTimestamp } from "../../redux/misc-data/misc-data.action";
import { setToken } from './../../redux/misc-data/misc-data.action';
import { setAgentInfo } from './../../redux/misc-data/misc-data.action';
import biometryPaySprint from "./../AEPSComponent/biometry-paysprint";

import DeviceDetails from "./DeviceDetails";
import FooterComponet from "../FooterComponent/FooterComponet";
const httpClient = axios.create();

class CMSLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            password: '',
            message: '',
            userIdErrMsg: '',
            passwordErrMsg: ''
        }
    }

    componentDidMount() {
        store.dispatch(setAgentInfo(''));
    }
    componentWillUnmount() {
    }

    checkValidation() {

        {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailId)) {
                return (true)
            }
            alert("You have entered an invalid email address!")
            return (false)
        }

    }



    enterUserId = (e) => {
        e.preventDefault();
        this.setState({
            userId: e.target.value,
            userIdErrMsg:''
        })
    }
    enterPassword = (e) => {
        e.preventDefault();
        this.setState({
            password: e.target.value,
            passwordErrMsg:''
        })
    }

    loginWithPassword = (event) => {
        event.preventDefault();
        this.setState({
            userIdErrMsg: '',
            passwordErrMsg: ''
        })



        if (this.state.userId != '' && this.state.password != '') {
            var data = {
                username: this.state.userId,
                password: this.state.password
            }
            var encData = btoa(JSON.stringify(data))

            const deviceInfo = DeviceDetails.fetchDeviceInfo();

            deviceInfo.then((deviceResponse) => {
                store.dispatch(setDeviceInfo(deviceResponse));
                console.log('deviceInfo...' + JSON.stringify(deviceResponse));
                window.open("/whitelabel/login?partner=cms&encData=" + encData, "_self")
            })
        } else {

            if (this.state.userId == '') {
                this.setState({
                    userIdErrMsg: 'Please enter user Id',
                })
            }
            if (this.state.password == '') {
                this.setState({
                    passwordErrMsg: 'Please enter password',
                })

            }
        }

    }

    readBanklLogo() {
        fetch(process.env.PUBLIC_URL + "/bank_images/bank_logo.txt")
            .then(data => data.text())
            .then(data => {
                store.dispatch(setBankLogoList(data.toUpperCase()));

                setTimeout(() => {
                    history.push('/dmt');
                    history.go();
                }, 400);

            });
    }


    render() {
        console.log('Inside render');
        return (
            <div>
                <div class="login-container">
                    <div class="container-fluid">
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                                <div class="login-box">
                                    <div class="login-head">
                                        <Link to='/dmt'>
                                            <button id='routeToDashBoard' hidden={true}></button>
                                        </Link>
                                        <center>
                                            <div class='cms-logo'></div>
                                        </center>
                                        {/* <img src="images/finxpay.png" alt="finXpay" class="img-fluid"></img> */}

                                        <p>Login to continue</p>
                                    </div>

                                    <div class="login-form">
                                        <form onSubmit={this.loginWithPassword}>
                                            <div class="form-floating">
                                                <input type="text" class="form-control" id="emailid" placeholder="User ID"
                                                    onChange={this.enterUserId}  />
                                                <label for="emailid">User ID</label>
                                                {this.state.userIdErrMsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.userIdErrMsg }
                                                    </div>}
                                            </div>
                                            <div class="form-floating">
                                                <input type="password" class="form-control" id="pass" placeholder="Password"
                                                    onChange={this.enterPassword}  />
                                                <label for="pass">Password</label>
                                                {this.state.passwordErrMsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.passwordErrMsg }
                                                    </div>}
                                            </div>
                                            <div class="md-form">
                                                {/* <img src="images/captcha.jpg" alt="captcha" class="img-fluid"/> */}

                                            </div>
                                            <button class="btn" type="submit">Login Now</button>
                                        </form>

                                        <p><a href="/reset-otp">Forgot password?</a></p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="logcopy">Copyright &copy; 2022 All rights reserved. <br />Powered by <a href="https://www.finxpay.co.in/" target="_blank">Uvva Infotech Pvt. Ltd.</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone
});

export default connect(mapStateToProps, null)(CMSLogin);
